import { getRemoteAppConfig } from './configs/configUtilities';

/**
 * Legacy app IDs that are supported
 */
export const VALID_LEGACY_APP_IDS = [
  'tax-preparer',
  'tir-admin',
  'accounting',
  'tax',
] as const;

export type LegacyAppId = (typeof VALID_LEGACY_APP_IDS)[number];

/**
 * Mapping from legacy appId to app config ID
 */
export const APP_ID_TO_CONFIG_ID: Record<LegacyAppId, string> = {
  'tax-preparer': 'ledgible-tax-preparer',
  'tir-admin': 'ledgible-tir-admin',
  accounting: 'ledgible-accounting',
  tax: 'ledgible-tax-payer',
};

/**
 * Mapping from appId to signup redirect URLs
 */
export const APP_ID_TO_SIGNUP_URL: Partial<Record<LegacyAppId, string>> = {
  'tax-preparer': 'https://ledgible.io/crypto-tax-pro-signup/',
  accounting:
    'https://ledgible.io/contact/?multi_select=Digital%20Asset%20Accounting',
  'tir-admin':
    'https://ledgible.io/contact/?multi_select=Tax%20Information%20Reporting',
};

/**
 * Check if an appId is a valid legacy app ID
 */
export const isValidLegacyAppId = (appId: string): appId is LegacyAppId => {
  return VALID_LEGACY_APP_IDS.includes(appId as LegacyAppId);
};

/**
 * Get the app config ID for a given legacy appId
 */
export const getConfigIdFromAppId = (appId: LegacyAppId): string => {
  return APP_ID_TO_CONFIG_ID[appId];
};

/**
 * Get the signup redirect URL for a given legacy appId
 * Returns null if there's no specific signup URL (should redirect to login)
 */
export const getSignupUrl = (appId: LegacyAppId): string | null => {
  return APP_ID_TO_SIGNUP_URL[appId] || null;
};

/**
 * Load the app config for a given legacy appId
 */
export const getAppConfigByAppId = async (appId: LegacyAppId) => {
  const configId = getConfigIdFromAppId(appId);
  return getRemoteAppConfig(configId as any);
};
